export const REQUEST_OPTIONS = {
  headers: {
    'Content-Type': 'application/octet-stream',
    Accept: 'application/octet-stream',
    observe: 'response'
  },
  responseType: 'blob' as any
}
